/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetUserSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUserSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUserSessionClientSecurity = {
  option1?: GetUserSessionClientSecurityOption1 | undefined;
  option2?: GetUserSessionClientSecurityOption2 | undefined;
};

export type GetUserSessionClientRequest = {
  /**
   * The user_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetUserSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUserSessionClientSecurityOption1$outboundSchema: z.ZodMiniType<
  GetUserSessionClientSecurityOption1$Outbound,
  GetUserSessionClientSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getUserSessionClientSecurityOption1ToJSON(
  getUserSessionClientSecurityOption1: GetUserSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    GetUserSessionClientSecurityOption1$outboundSchema.parse(
      getUserSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUserSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUserSessionClientSecurityOption2$outboundSchema: z.ZodMiniType<
  GetUserSessionClientSecurityOption2$Outbound,
  GetUserSessionClientSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getUserSessionClientSecurityOption2ToJSON(
  getUserSessionClientSecurityOption2: GetUserSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    GetUserSessionClientSecurityOption2$outboundSchema.parse(
      getUserSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUserSessionClientSecurity$Outbound = {
  Option1?: GetUserSessionClientSecurityOption1$Outbound | undefined;
  Option2?: GetUserSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetUserSessionClientSecurity$outboundSchema: z.ZodMiniType<
  GetUserSessionClientSecurity$Outbound,
  GetUserSessionClientSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetUserSessionClientSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetUserSessionClientSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getUserSessionClientSecurityToJSON(
  getUserSessionClientSecurity: GetUserSessionClientSecurity,
): string {
  return JSON.stringify(
    GetUserSessionClientSecurity$outboundSchema.parse(
      getUserSessionClientSecurity,
    ),
  );
}

/** @internal */
export type GetUserSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetUserSessionClientRequest$outboundSchema: z.ZodMiniType<
  GetUserSessionClientRequest$Outbound,
  GetUserSessionClientRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getUserSessionClientRequestToJSON(
  getUserSessionClientRequest: GetUserSessionClientRequest,
): string {
  return JSON.stringify(
    GetUserSessionClientRequest$outboundSchema.parse(
      getUserSessionClientRequest,
    ),
  );
}
